import { render, staticRenderFns } from "./EditProjectDialog.vue?vue&type=template&id=221263ae&"
import script from "./EditProjectDialog.vue?vue&type=script&lang=ts&"
export * from "./EditProjectDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports